import { Action } from "../../../common/actions/core/action";
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";
import { ActionHandler } from "../../../common/actions/core/action-handler";
import GlobalSpinnerService from "../../../common/services/spinner/global-spinner.service";
import NoAuthService from "../../services/noauth.service";
import { NoAuthOpenPreInfoFormAction } from "./pre-info-form-dialog.action";

/* @ngInject */
export default class NoAuthPreInfoFormDialogController implements ActionHandler {
    private dialogElement;
    private aggreement: string;
    private msisdn: string;
    public offerId?: string;
    public paymentType?: string;
    public paymentTypeMessage?: string;

    protected approve: () => void;

    constructor(
        private $sce,
        private $translate,
        private $element,
        private actionDispatcher: ActionDispatcherService,
        private globalSpinner: GlobalSpinnerService,
        private noAuthService: NoAuthService
    ) {
        this.actionDispatcher.register(this);
    }

    public $postLink() {
        this.dialogElement = this.$element.find('#pre-info-form-dialog').remodal();
    }

    public $onDestroy() {
        this.actionDispatcher.unregister(this);
        this.dialogElement.destroy();
    }

    public handle(action: Action) {
        if (action instanceof NoAuthOpenPreInfoFormAction) {
            this.msisdn = action.msisdn;
            this.approve = action.onApprove;
            this.offerId = action.offerId;
            this.paymentType = action.paymentType;
            if (action.paymentType == 'mobile') {
                this.openDialogMobile();
            } else {
                this.openDialog();
            }
        }
    }

    public onClick() {
        this.close();
    }

    private openDialogMobile() {
        this.globalSpinner.startIfNotActivated();
        this.noAuthService.getEulaUrl(this.msisdn).then(resp => {
            var httpPattern = /(\<a([^>]*?)(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
            resp.eulaTextUrl = resp.eulaTextUrl.replace(httpPattern, '$1?openInExternalBrowser=true" target="_blank');
            var mailPattern = /((mailto):[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
            resp.eulaTextUrl = resp.eulaTextUrl.replace(mailPattern, 'javascript:void(0)');

            this.aggreement = this.$sce.trustAsHtml(resp.eulaTextUrl);
            this.dialogElement.open();
        }).catch(error => {
            console.log('eulaModel not found');
        }).finally(() => this.globalSpinner.stop());
    }

    private openDialog() {
        this.noAuthService
            .getContractByKey(this.msisdn, 'pre_info_contract', this.offerId)
            .then(contract => {
                if (this.paymentType) {
                    const paymentMesssage = 'payment.' + this.paymentType + '.message';
                    this.$translate(paymentMesssage).then(value => {
                        contract = contract.replace('{{paymentType}}', value);
                    }).finally(() => {
                        this.aggreement = this.$sce.trustAsHtml(contract);
                        this.dialogElement.open();
                    });
                } else {
                    this.aggreement = this.$sce.trustAsHtml(contract);
                    this.dialogElement.open();
                }
            }).finally(() => this.globalSpinner.stop());
    }

    public onCancel() {
        this.close();
    }

    private close() {
        this.dialogElement.close();
    }

    public onApprove() {
        this.close();
        this.approve();
    }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/pre-info-form-dialog/pre-info-form-dialog.controller.ts